import { Injectable } from "@angular/core";
import { BehaviorSubject} from "rxjs";
import { environment } from "src/environments/environment";
import { AdminMenuStructure } from "../components/admin-view/admin-view.component";
import { AdminMenuItem } from "../components/admin-view/admin-menu-item.component";
import { WhiteLabelContextService } from "./white-labels/white-label-context.service";
import { Router } from "@angular/router";
import { NavigationService } from "./NavigationService.service";
import { UserService } from "src/app/services/authentication/user.service";

export type menuItem = {
  id: number;
  title: string;
  active: boolean;
  iconPath: string;
  navigateTo: string;
}

@Injectable({ providedIn: "root" })
export class AdminService {
  public environment = environment;
  public menuStructure: AdminMenuStructure;
  public currentActiveItem: BehaviorSubject<AdminMenuItem>;

  constructor(
    private whiteLabelContextService: WhiteLabelContextService,
    private router: Router,
    public navigationService: NavigationService,
    private userService: UserService
  ) {
    this.initializeMenu();
  }

  private initializeMenu(): AdminMenuStructure {
    const wlSlug = this.whiteLabelContextService.getCurrentWhiteLabelSlug();
    if (typeof wlSlug !== "string" || wlSlug.trim().length < 1) {
      console.error("Failed to get white label slug.");
      this.router.navigate([this.navigationService.pageNotFound]);
      return;
    }

    this.menuStructure = new AdminMenuStructure(wlSlug);
    const firstMenuItem = this.menuStructure.getMenuItems()[0];
    this.currentActiveItem = new BehaviorSubject(firstMenuItem);
    this.currentActiveItem.value.setActive();

    this.userService.canEditPriceFactor$.subscribe((canEdit) => {
      if (canEdit) 
        this.menuStructure.addManagePricingMenuItem();
      else 
        this.menuStructure.removeManagePricingMenuItem();
    });

    return this.menuStructure;
  }

  public setActiveTab(menuItemSlug: string) {
    this.currentActiveItem.value?.setNotActive();
    const menuItem = this.menuStructure.getMenuItems().find((x) => { return x.slug === menuItemSlug; });
    menuItem?.setActive();
    this.currentActiveItem.next(menuItem);
  }
}
